import { render, staticRenderFns } from "./CreateFiscalFixedAssetCategory.vue?vue&type=template&id=af9dfc76"
import script from "./CreateFiscalFixedAssetCategory.vue?vue&type=script&lang=js"
export * from "./CreateFiscalFixedAssetCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports